import { useCallback, useEffect, useState } from 'react';
import useReveal from './useReveal';
import './EngagementGallery.css';

function EngagementGallery({ photos }) {
  const [ref, visible] = useReveal();
  const [selected, setSelected] = useState(null);

  const close = useCallback(() => setSelected(null), []);
  const step = useCallback(
    (dir) =>
      setSelected((i) => (i === null ? i : (i + dir + photos.length) % photos.length)),
    [photos.length]
  );

  useEffect(() => {
    if (selected === null) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [selected, close, step]);

  if (photos.length === 0) return null;

  const total = String(photos.length).padStart(2, '0');

  return (
    <section ref={ref} className={`engagement${visible ? ' is-visible' : ''}`}>
      <header className="engagement-header">
        <p className="section-eyebrow">The Engagement</p>
        <h2 className="section-title">She said yes</h2>
      </header>

      <div className="engagement-grid">
        {photos.map(({ filename }, i) => (
          <button
            key={filename}
            type="button"
            className="engagement-item"
            onClick={() => setSelected(i)}
          >
            <img src={`/photos/engagement/${filename}`} alt="" loading="lazy" />
          </button>
        ))}
      </div>

      {selected !== null && (
        <div className="engagement-lightbox" role="dialog" aria-modal="true" onClick={close}>
          <img
            src={`/photos/engagement/${photos[selected].filename}`}
            alt=""
            onClick={(e) => e.stopPropagation()}
          />
          <button
            type="button"
            className="engagement-lightbox-close"
            aria-label="Close"
            onClick={close}
          >
            ×
          </button>
          <button
            type="button"
            className="engagement-lightbox-prev"
            aria-label="Previous"
            onClick={(e) => {
              e.stopPropagation();
              step(-1);
            }}
          >
            ‹
          </button>
          <button
            type="button"
            className="engagement-lightbox-next"
            aria-label="Next"
            onClick={(e) => {
              e.stopPropagation();
              step(1);
            }}
          >
            ›
          </button>
          <span className="engagement-lightbox-index">
            {String(selected + 1).padStart(2, '0')} / {total}
          </span>
        </div>
      )}
    </section>
  );
}

export default EngagementGallery;
